import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Header } from "../../components/Header/Header";
import classNames from "classnames";
import Slider from "../../components/Slider/Slider";
import { Button } from "../../components/Button/Button";
import { VarianButtonEnum } from "../../enum/Button/variantButton.model";
import { IconModelEnum } from "../../enum/Button/iconButton.model";
import { Typography } from "../../components/typography";
import { SelectedVariants } from "../../components/SelectedVariants/SelectedVariants";
import { Dropdown } from "../../components/Dropdown/Dropdown";
import { DisclaimerSection } from "../../components/Disclaimer-Section/DisclaimerSection";
import { colorButton } from "../../enum/Button/colorButton.model";
import { DataType } from "./formType";
import { DataContainerContext } from "../../context/DataContainerContext";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import DataContainer from "../../services/DataContainer";
import dataContainer from "../../services/DataContainer";
import PdfDocument from "../../components/PdfDocument/PdfDocument";
import { announceToScreenReader } from "../../utils/accessibility";
import {
  ConfiguratorOptions,
  ContactDealerFormSettings,
  ContactDealerSettings,
  DisclaimerTexts,
  DummyData,
  HiddenOptions,
  MainCategories,
  MainSettings,
  MainTopMenus,
  MarketSettings,
  RodSettings,
  SummarySettings
} from "../../enum/enums";
import { Modal } from "../../components/Modal/Modal";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Mousewheel } from "swiper";
import { customBreakpoints } from "./customBreakpoints";
import { getLocales } from "../../services/ApiService";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import "../../components/Slider/swiper.css";
import useRenderConfig from "../../utils/useRenderConfig";
import { ImageFormat, ImageType, RenderConfiguration } from "../../utils/useRenderOnDemand.types";
import useRenderOnDemand from "../../utils/useRenderOnDemand";
import { AdobeEventActions } from "../../enum/adobe/adobeEventActions";
import { StepNumbers } from "../../enum/adobe/stepNumbers";
import { AdobeEventType } from "../../enum/adobe/adobeEventType";
import { StepNames } from "../../enum/adobe/stepNames";
import { mapToAdobeComponentStructure, SubStepNames } from "../../enum/adobe/subStepNames";
import { FileFormatTypes } from "../../enum/adobe/fileFormatTypes";
import { SalesforceForm } from "../../components/Form/SalesforceForm";
import { AdobeCampaignForm } from "../../components/Form/AdobeCampaignForm";
import { useDownloadConfigurationImages } from "../../utils/useDownloadConfigurationImages";
import { InfoShield } from "../../components/InfoShield/InfoShield";
import { Page } from "../../components/Page/Page";
import { Link } from "../../components/Menu/types";
import { ActiveComponentGroup, Variation } from "../../context/DataContainerContext/types";

SwiperCore.use([Mousewheel]);

const FORBIDDEN_COMPONENTS = [
  ConfiguratorOptions.CHASSI_TYPE,
  HiddenOptions.HIDDEN_OPTIONS,
  ConfiguratorOptions.COLORS,
];

function Summary() {
  const { hash, modelNameFromUrl } = useParams();
  const [searchParams] = useSearchParams();
  const [loadVariations, setLoadVariations] = useState(false);
  const [renderControlKey, setRenderControlKey] = useState(0);
  const [regionSelected, setRegionSelected] = useState("");
  const {
    jumpToGroup,
    modelName,
    data,
    currentLocale,
  } = useContext(DataContainerContext);

  useEffect(()=> {
    if(modelNameFromUrl?.includes("_rod")) {
      window.location.href = window.location.href.replace("_rod", "");
    }
    if(!DataContainer.mLoadedData && data?.length > 0){
      data?.map((item: any) => {
        const mName = (modelName ? modelName : modelNameFromUrl)?.split("_")[0];
        if (item.product_info.description === mName) {
          dataContainer.loadData(() => {
            if(renderControlKey === 0){
              dataContainer.instance();
              const url = `${DataContainer.sectionKey(MarketSettings.MARKET_SETTINGS, MarketSettings.CONFIGURATOR_URL)}truck-builder.html#/${currentLocale?.locale}`;
              dataContainer.loadSelectionFromHash(hash, url);
              setSelectedVariations(dataContainer.getSelectedVariations());
              setRenderControlKey(Math.random());
            }
          },
          currentLocale,
          item.id,
          item.cached_url
          );
        }
      });
    }else if(renderControlKey === 0 && DataContainer.mLoadedData){
      const defaultViewPoint = dataContainer.getProductViewPoints()?.find((vp: any) => vp.name === "010");
      dataContainer.setCurrentViewPoint(`${defaultViewPoint}_${steeringwheel_position.toUpperCase()}`);
      setRenderControlKey(Math.random());
    }
  }, [data, currentLocale, dataContainer.mLoadedData]);


  const [formData, setFormData] = useState<DataType>(DummyData);
  const [requiredFields, setRequiredFields] = useState(true);
  const [resetForm, setResetForm] = useState(true);
  const [captchaRequired, setCaptchaRequired] = useState(true);
  const [correctCaptcha, setCorrectCaptcha] = useState(true);
  const [requiredInput, setRequiredInput] = useState(false);
  const [isAugmentedOpen,setIsAugmentdOpen] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState<boolean>(true);
  const [privacyCheckboxErrorIndicator, setPrivacyCheckboxErrorIndicator] = useState<boolean>(true);
  const [marketingCheckboxErrorIndicator, setMarketingheckboxErrorIndicator] = useState<boolean>(true);

  const formRef: any = useRef(null);
  const variationsRef: any = useRef(null);
  const resetRef: any  = useRef(null);
  const chosenDealerRef: React.LegacyRef<HTMLDivElement> = useRef<HTMLDivElement>(null);
  const currentSegment = localStorage.getItem("segment");

  const getUniqueHashForSelections = () => {
    return `${window.location.href}`;
  };
  const [selectedVariations, setSelectedVariations] = useState<Variation[]>(() => { return DataContainer.getSelectedVariations();});
  const [sliderViewPoints, setSliderViewPoints] = useState<any>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [contactFormModalOpen, setContactFormModalOpen] = useState(false);
  const [exteriorImageSource, setExteriorImageSource] = useState<string>("");
  const [interiorImageSource, setInteriorImageSource] = useState<string>("");
  const [mapSrc, setMapSrc] = useState("");
  const [localeFromDropdown, setLocaleFromDropdown] = useState("");
  const [localeIDfromDropdown, setLocaleIDfromDropdown] = useState("");
  const [localesList, setLocalesList] = useState([]);
  const [marketsWithConfigURL, setMarketsWithConfigURL] = useState<any>([]);
  const [salesforceStatus, setSalesforceStatus] = useState<string>("");
  const [salesforceMessage, setSalesforceMessage] = useState<string>("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const currentProductData = data.find((product: any) => product.id === DataContainer._productId);

  const pattern = /[a-zA-Z0-9]+[\\.]?([a-zA-Z0-9]+)?[\\@][a-z0-9]{2,20}[\\.][a-z]{2,9}/;
  const locale = currentLocale?.locale?.split("-")[0];
  const market = currentLocale?.locale?.split("-")[1];

  useEffect(() => {
    setMapSrc(`https://dealerlocatorfrontend.application.volvotrucks.com/?isTruckConfigurator=true&lang=${locale}&market=${market}&ignoreLocation=true&isSalesDealersOnly=true&t=`+Math.floor(Math.random() * 1000));
    if (currentLocale?.locale === "en-en") {
      setMapSrc("https://dealerlocatorfrontend.application.volvotrucks.com/?isTruckConfigurator=true&ignoreLocation=true&isSalesDealersOnly=true&t="+Math.floor(Math.random() * 1000));
    } else if(currentLocale?.locale === "te-st") {
      setMapSrc("https://dealerlocatorfrontend.application.volvotrucks.com/?isTruckConfigurator=true&lang=sv-se&market=se&ignoreLocation=true&isSalesDealersOnly=true&t="+Math.floor(Math.random() * 1000));
    }
  },[currentLocale]);

  function mapToObject(array: any[], keyProp: string, valueProp: string, keyReplacer: { (key: number): any;}) {
    return array.reduce((acc, obj) => {
      if (obj && obj[keyProp] !== undefined && obj[valueProp] !== undefined) {
        acc[keyReplacer(obj[keyProp])] = obj[valueProp];
      }
      return acc;
    }, {});
  }

  useEffect(() => {
    const selectedVariations = DataContainer.mSelectedVariations.map((id) => DataContainer?.findVariationBy(id));
    
    function replaceWithKey(obj: any, str: any) {
      for (const [key, value] of Object.entries(obj)) {
        if (key === str) {
          return value;
        }
      }
      return str;
    }
    const selectedOptions = mapToObject(selectedVariations, "component_id", "original_key", (key: number) => replaceWithKey(mapToAdobeComponentStructure, DataContainer.findComponentById(key)?.name));

    if(Object.keys(selectedOptions).length !== 0) {
      const selectedColorizer = dataContainer.getSelectedColorFromColorizer();
      if (selectedColorizer?.key) {
        selectedOptions[mapToAdobeComponentStructure["Colors"]] = selectedColorizer.key;
        selectedOptions[mapToAdobeComponentStructure["ColorName"]] = selectedColorizer.key.substring(selectedColorizer.key.indexOf(" ") + 1);
        selectedOptions[mapToAdobeComponentStructure["ColorCode"]] = selectedColorizer.key.substring(0, selectedColorizer.key.indexOf(" "));
      }
      const selectedEngine = selectedOptions["Engine Model"];
      selectedOptions[mapToAdobeComponentStructure["EngineType"]] = selectedEngine?.includes("_lng") ? "lng" : selectedEngine?.includes("_cng") ? "cng" : selectedEngine?.includes("_euro5") ? "euro5" : selectedEngine?.includes("_euro3") ? "euro3" : selectedEngine?.includes("electric") ? "electric" : "euro6";
      selectedOptions[mapToAdobeComponentStructure["Segment"]] = currentSegment ? currentSegment?.replace("_", " ").toUpperCase() : "No segment selected";
      selectedOptions[mapToAdobeComponentStructure["Model"]] = modelName ? `Volvo ${modelName?.toUpperCase()}` : `Volvo ${modelNameFromUrl?.toUpperCase()}`;
    }
    
    for (const [key] of Object.entries(selectedOptions)) {
      let found = false;
      for (const [, value2] of Object.entries(mapToAdobeComponentStructure)) {
        if (key === value2) {
          found = true;
        }
      }
      if (!found) {
        delete selectedOptions[key];
      }
    }
    
    if (Object.keys(selectedOptions).length !== 0) {
      DataContainer.sendDataToAdobeDataLayer(AdobeEventType.APPLICATION_INTERACTION, StepNumbers.STEP_8, StepNames.SUMMARY, SubStepNames.SUMMARY, AdobeEventActions.SUMMARY_REACHED, selectedOptions, "");
    }
  }, [DataContainer.mSelectedVariations]);

  const renderConfig = useRenderConfig();
  const exteriorViewPoints = DataContainer.getProductViewPoints() && DataContainer.getProductViewPoints().map((vp: { name: string }) => vp.name);


  const steeringwheel_position = DataContainer.sectionKey(MarketSettings.MARKET_SETTINGS, MarketSettings.STEERINGWHEEL_POSITION);  

  const isHighRes = searchParams.get("secret") === "highres";

  const getRenderSpec = useCallback((sequence: string, forInterior?: boolean, downloadImages?: boolean, formatJpg?: boolean, highResolution?: boolean) => {
    const interiorSelectedVariations = DataContainer.getSelectedVariations().filter((variant: any) => dataContainer.findComponentGroupByName(variant?.component_group_name)?.name === ConfiguratorOptions.INTERIOR);
    const configuration: Record<string, Record<string, string>> = {};

    const mirrorsForInterior = dataContainer.findSelectedVariantByComponentNameAndComponentGroup(ConfiguratorOptions.MIRRORS, ConfiguratorOptions.EXTERIOR)?.original_key;
    const cabsForInterior = dataContainer.findSelectedVariantByComponentNameAndComponentGroup(ConfiguratorOptions.CABS, ConfiguratorOptions.EXTERIOR)?.original_key;

    const getOriginalKeysAndComponentNames = interiorSelectedVariations.map((el: { component_id: number; original_key: string; }) => {
      const componentName = dataContainer.findComponentById(el?.component_id)?.name;              
      return {
        originalKey: el?.original_key,
        componentName: componentName,
      };
    });
    configuration[ConfiguratorOptions.INTERIOR] = {};
    configuration[ConfiguratorOptions.INTERIOR][ConfiguratorOptions.MIRRORS] = mirrorsForInterior;
    configuration[ConfiguratorOptions.INTERIOR][ConfiguratorOptions.CABS] = cabsForInterior;
    getOriginalKeysAndComponentNames.forEach((singleKeyNamePair: { componentName: string | number; originalKey: string; }) => {              
      configuration[ConfiguratorOptions.INTERIOR][singleKeyNamePair.componentName] = singleKeyNamePair.originalKey;          
    });

    const interiorRenderConfig: RenderConfiguration = {
      productId: renderConfig.productId,
      componentGroups: configuration,
      productName: renderConfig.productName?.toUpperCase()
    };

    const width = highResolution ? 3680 : 2500;
    const height = highResolution ? 2160 : 1875;

    return {
      sequence: sequence,
      attributes: { 
        steeringwheel_position: steeringwheel_position,
        stage: !downloadImages? "studio" : "transparent"
      },
      renderVersion: !downloadImages ? parseInt(DataContainer.sectionKey(RodSettings.ROD_SETTINGS, `${modelNameFromUrl?.split("_")[0]}_renderversion`)) : 3,
      configuration: forInterior ? interiorRenderConfig : renderConfig,
      format: forInterior ? ImageFormat.JPEG : formatJpg ? ImageFormat.JPEG : ImageFormat.PNG,
      width,
      height,
      type: ImageType.Image,
      compressionQuality: 100,
    };
  },[renderConfig, steeringwheel_position, modelNameFromUrl]);

  const exteriorRenderSpec = getRenderSpec("010");
  const interiorRenderSpec = getRenderSpec("bedView", true);
  const exteriorImageInformation = useRenderOnDemand(exteriorRenderSpec);
  const interiorImageInformation = useRenderOnDemand(interiorRenderSpec);
  const { downloadImages, isLoadingZip, isLoadingJPEGZip } = useDownloadConfigurationImages();

  const selectionHash = JSON.stringify(renderConfig);
  
  useEffect(() => {
    // Reset whenever the configuration changes
    exteriorViewPoints && setExteriorImageSource("");
  }, [selectionHash]);
  
  //===============================Form Validation========================================================
  const isEmptyValue = (value: string | { name: string }) => {
    if(typeof value === "string") {
      return value === "";
    }
    else if (typeof value === "object") {
      return value.name === ""; 
    }
  };  
  
  const isRequiredFieldCorrectlyFilled = (data: DataType): boolean => {
    const requiredFields = Object.entries(data).filter(([key]) => DataContainer.sectionKey(ContactDealerFormSettings.CONTACT_DEALER_FORM,`contact_dealer_${key}_required`) === "true");
    const allRequiredFieldsAreFilled = requiredFields.map(([, value]: any) => !isEmptyValue(value));
    return allRequiredFieldsAreFilled.every((field: any) => field == true);
  };

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, name: string) => {
    if (name === "privacyText" || name === "pronounTitle") {
      setPrivacyCheckboxErrorIndicator(!e.target.checked);   
    } else if (name === "marketingCheckbox") {
      setMarketingheckboxErrorIndicator(!e.target.checked);
    }
    setFormData({ ...formData, [e.target.name]: e.target.checked });
  };  

  const checkEmailValidity = () => {
    const result = pattern.test(formData.email);
    setIsEmailValid(result);
    return result;
  };

  const onChangeDropdown = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onChangeRegions = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setFormData({ ...formData, chosen_dealer: {name: e.target.value} });
    setRegionSelected(e.target.value);
  };  

  const getDealerInformation = (message: any) => {    
    if (message.data.from && message.data.from === "dealer_locator") {            
      setFormData({ ...formData, chosen_dealer: message.data.data });
      chosenDealerRef.current && chosenDealerRef.current.scrollIntoView({behavior: "smooth", block: "center"});
    }    
  };  

  const allSalesforceRequiredFieldsAreFilled = () => {
    const inputFields = document.getElementsByTagName("input");    
    const selectFields = document.getElementsByTagName("select");

    const filteredInputRequiredFields = Object.values(inputFields).filter((field: any) => DataContainer.sectionKey(ContactDealerFormSettings.CONTACT_DEALER_FORM, `contact_dealer_${field.name.toLowerCase()}_required`) === "true");
    
    const inputRequiredFields = Object.values(filteredInputRequiredFields).map((field: any) => {
      if(field?.value === "") {
        return false;
      } else if (field.value === "on" && field?.checked == false) {
        return false;
      } else {
        return true;
      }
    });

    const selectRequiredFields = Object.values(selectFields).filter((field: any) => DataContainer.sectionKey(ContactDealerFormSettings.CONTACT_DEALER_FORM, `contact_dealer_${field.name.toLowerCase()}_required`) === "true")
      .map((field: any) => field.value).every((field: any) => field !== "");

    return (inputRequiredFields.every((field) => field == true) && selectRequiredFields == true);
  }; 

  //======================================Form Validation(above)===================================================
  const submitForm = async (data: DataType) => {
    if (isSubmitting) return;

    if (isSalesforceActive) {
      if(allSalesforceRequiredFieldsAreFilled() && checkEmailValidity() && correctCaptcha) {
        const requestedFrom = "ContactForm";
        setIsSubmitting(true);
        DataContainer.sendDataToSalesForce(data, requestedFrom, currentLocale?.locale as string, getUniqueHashForSelections(), exteriorImageSource, async (res: any) => {
          setIsSubmitting(false);
          if (res) {
            setSalesforceStatus(res.Status);
            setSalesforceMessage(res.Message);
            setContactFormModalOpen(true);
            setFormData(DummyData);
            setResetForm(!resetForm);
            setRenderControlKey(Math.random());
            resetRef.current.reset();
            DataContainer.sendDataToAdobeDataLayer(AdobeEventType.APPLICATION_INTERACTION, StepNumbers.STEP_8, StepNames.SUMMARY, SubStepNames.SUMMARY, AdobeEventActions.FORM_SUBMIT, {}, "");
            setRequiredInput(false);
            announceToScreenReader("Form submitted successfully");
          } else {
            console.error("Something went wrong with your request");
            announceToScreenReader("Form submission failed. Please try again.");
          }
        });
      } else {
        setRequiredFields(false);
        setRequiredInput(true);
        announceToScreenReader("Please correct the errors in the form before submitting");
      }
    } else {
      if(captchaRequired && correctCaptcha && isRequiredFieldCorrectlyFilled(data) && checkEmailValidity() && data.pronounTitle == true) {
        setIsSubmitting(true);
        try {
          await DataContainer.sendContactInfoAndConfigurationToSeller(data, currentLocale?.locale as string, getUniqueHashForSelections(), exteriorImageSource);
          setRequiredFields(true);
          setFormData(DummyData);
          setResetForm(!resetForm);
          setRenderControlKey(Math.random());
          resetRef.current.reset();
          setRequiredInput(false);
          DataContainer.sendDataToAdobeDataLayer(AdobeEventType.APPLICATION_INTERACTION, StepNumbers.STEP_8, StepNames.SUMMARY, SubStepNames.SUMMARY, AdobeEventActions.FORM_SUBMIT, {}, "");
          setContactFormModalOpen(true);
        } finally {
          setIsSubmitting(false);
        }
      } else {
        setRequiredFields(false);
        setRequiredInput(true);
      }
    }
  };

  window.addEventListener("message", getDealerInformation, true);

  if (!DataContainer.getSelectedVariations().length) {
    DataContainer.loadSelectionFromHash(hash);
  }

  const scrollToMap = () : any => {
    formRef.current && formRef.current.scrollIntoView({behavior: "smooth"});
  };

  function componentGroupsClickEvent(componentGroups: ActiveComponentGroup) {
    jumpToGroup(componentGroups.name);
    navigate(`/${currentLocale?.locale}/configurator/${modelName ? modelName : modelNameFromUrl}`);
  }
  const menuLinks = useMemo((): Link[] => {
    return [
      {
        name:
          DataContainer.sectionKey(
            MainTopMenus.MAIN_TOPMENU,
            MainTopMenus.YOUR_VOLVO,
          ) +
          ` ${
            currentProductData
              ? currentProductData?.product_info?.name.replace("Volvo", "")
              : ""
          }`,
        link: "#",
        activeClass: true,
      },
      {
        name: DataContainer.sectionKey(
          MainTopMenus.MAIN_TOPMENU,
          MainTopMenus.OVERVIEW_TITLE,
        ),
        link: "#overview",
        activeClass: false,
      },
    ];
  }, [currentProductData, data]);

  useEffect(() => {
    setExteriorImageSource(exteriorImageInformation.urlAssets[0]);
    setInteriorImageSource(interiorImageInformation.urlAssets[0]);
  }, [exteriorImageInformation, interiorImageInformation]);

  useEffect(() => {
    //ignore cases when data are not loaded.
    if(!DataContainer.mLoadedData){
      return;
    }
    if(loadVariations && !DataContainer.getSelectedVariations().length) {
      setLoadVariations(false);
    } else {
      setSelectedVariations(DataContainer.getSelectedVariations());
    }
  }, [loadVariations]);

  useEffect(() => {
    //ignore cases when data are not loaded.
    if(!DataContainer.mLoadedData){
      return;
    }

    if (DataContainer.mLoadedData) {
      if(!sliderViewPoints?.length) setSliderViewPoints(DataContainer.getProductViewPoints());
    }

    getLocales().then( async (res) => {
      const allLocales = res.data.data;
      const getAllMarketsData = await dataContainer.getApplicationDataForAllMarkets();      
      const getLocalesWithConfigURL = getAllMarketsData.find((options: {id: number, name: string}) => options.name === "Market.Settings").keys.find((key: {id: number, key: string}) => key.key === "configurator_url").captions;
      const filteredLocales = allLocales.filter((singleLocale: any) => getLocalesWithConfigURL.some((localeWithURL: any) => localeWithURL.locale_id === singleLocale.id));
      setLocalesList(filteredLocales);
      setMarketsWithConfigURL(getLocalesWithConfigURL);
    });
  }, [DataContainer.mLoadedData, sliderViewPoints]);  

  const getDropdownRedirectionURL = (id: any) => { 
    return marketsWithConfigURL.find((singleMarket: {id: number, locale_id: number, value: string}) => singleMarket?.locale_id == id )?.value;
  };  

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  const filteredVariations = Array.from(new Set(selectedVariations)).filter((variation) => {
    const componentName = dataContainer.findComponentById(variation?.component_id)?.name;
    return componentName && !FORBIDDEN_COMPONENTS.includes(componentName);
  });
  const translateComponentName = (variant: Variation) => {
    if(!dataContainer.variationBelongsToColorizer(variant)) {
      const component = DataContainer.findComponentById(variant?.component_id);
      const componentGroup = DataContainer.getComponentGroups().find((cg: any) => cg.id === component?.group_id);
      return DataContainer.sectionKey(MainTopMenus.MAIN_TOPMENU, `${componentGroup.name.toLowerCase()}_${component.name.toLowerCase()}_title`);
    } else {
      return DataContainer.sectionKey(MainTopMenus.MAIN_TOPMENU, "exterior_colors_title");
    }
  };

  const camelize = (str: string, makeFirstUpper: boolean) => {
    return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
      if (+match === 0) return "";
      return index === 0 && !makeFirstUpper ? match.toLowerCase() : match.toUpperCase();
    });
  };

  const translateVariation = (variation: Variation) => {
    const component = DataContainer.findComponentById(variation.component_id);
    if(!dataContainer.variationBelongsToColorizer(variation)) {
      let sectionKey = `Options.${component.name}`;
      const componentGroup = DataContainer.findComponentGroupByComponentId(variation.component_id);
      if (["interior", "exterior"].includes(componentGroup.name.toLowerCase())){
        if (["Ext_trim_levels", "Int_trim_levels"].includes(component.name)) {
          sectionKey = `${`Options.${componentGroup.name}${camelize(component.name.split("_").slice(1).join("_").replaceAll("_"," "), true)}`}`;
        }
      }
      let variationTranslation = DataContainer.sectionKey(
        sectionKey,`${variation.original_key}_title`) + " " + DataContainer.sectionKey(sectionKey,`${variation.original_key}`);
      if(variationTranslation.includes(variation.original_key)){
        variationTranslation = DataContainer.sectionKey(sectionKey,`${variation.original_key}`);
      }
      return variationTranslation;
    } else {
      return variation.key;
    }
  };

  const showCTA = useCallback((sectionName: string, key: string) => {
    return DataContainer?.sectionKey(sectionName, key) === "true";
  }, [data]);

  const isContactFormActive = useMemo(() => 
    showCTA(ContactDealerSettings.CONTACT_DEALER_SETTINGS, ContactDealerSettings.SHOW_CONTACT_FORM), 
  [showCTA, data]);

  const isSelectMarketActive = useMemo(() => 
    showCTA(ContactDealerSettings.CONTACT_DEALER_SETTINGS, ContactDealerSettings.SELECT_MARKET), 
  [showCTA, data]);

  const isSalesforceActive = useMemo(() => {
    return showCTA(ContactDealerSettings.CONTACT_DEALER_SETTINGS, ContactDealerSettings.SALESFORCE);
  },
  [showCTA, data]);

  const isProdA = process.env.REACT_APP_IS_PROD_A === "true";
  const showSalesforce = isSalesforceActive && !isProdA;

  const isEmailForLocalesActive = useMemo(() => 
    showCTA(ContactDealerSettings.CONTACT_DEALER_SETTINGS, ContactDealerSettings.SHOW_EMAIL_FOR_LOCALES), 
  [showCTA, data]);

  const isContactDealerLinkActive = useMemo(() => 
    showCTA(ContactDealerSettings.CONTACT_DEALER_SETTINGS, ContactDealerSettings.CONTACT_DEALER_LINK_BUTTON), 
  [showCTA, data]);

  const isDownloadProductImageActive = useMemo(() => 
    showCTA(ContactDealerSettings.CONTACT_DEALER_SETTINGS, ContactDealerSettings.SHOW_DOWNLOAD_PRODUCT_IMAGE), 
  [showCTA, data]);

  const isDownloadPdfActive = useMemo(() => 
    showCTA(ContactDealerSettings.CONTACT_DEALER_SETTINGS, ContactDealerSettings.SHOW_DOWNLOAD_PDF), 
  [showCTA, data]);

  const isEnvelopeIconActive = useMemo(() => 
    showCTA(ContactDealerSettings.CONTACT_DEALER_SETTINGS, ContactDealerSettings.SHOW_ENVELOPE_ICON), 
  [showCTA, data]);

  const isChooseDealerActive = useMemo(() => 
    showCTA(ContactDealerSettings.CONTACT_DEALER_SETTINGS, ContactDealerSettings.SHOW_CHOOSE_DEALER), 
  [showCTA, data]);

  return ( renderControlKey === 0 ?
    <div className="flex absolute z-50 flex-col items-center justify-center w-full h-full bg-white text-black">
      <div>...</div>
    </div> :
    <div>
      <Page>
        <Header
          key={renderControlKey}
          title={dataContainer.sectionKey(MainSettings.MAIN_CATEGORIES, MainCategories.SUMMARY_CATEGORY) ? dataContainer.sectionKey(MainSettings.MAIN_CATEGORIES, MainCategories.SUMMARY_CATEGORY) : "Summary"}
          links={menuLinks}
          onClickEvent={() => ""}
          refToScroll={variationsRef}
          onSidebarItemClickEvent={(component) => componentGroupsClickEvent(component)}
          listSidebar={DataContainer?.getComponentGroups()?.filter((item: any) => item.name !== HiddenOptions.HIDDEN_OPTIONS)}
        />

        {sliderViewPoints?.length && (
          <div
            className={`object-cover relative z-0 ${
              // Mobile and when only the "Augmented Reality" button shows → 80vh
              isMobile &&
                !(
                  isEmailForLocalesActive ||
                  isContactDealerLinkActive
                )
                ? "h-[calc(80vh-64px)]"
                // When both buttons "Share with dealer" and "Save for later" are false → 100vh
                : !(
                  isEmailForLocalesActive ||
                  isContactDealerLinkActive
                )
                  ? "h-[calc(100vh-64px)]"
                  // Default responsive heights
                  : "h-[calc(60vh-64px)] sm:h-[calc(55vh-64px)] md:h-[calc(80vh-64px)] lg:h-[calc(75vh-64px)]"
            }`}
          >
            <Slider
              onSummary={true}
              environment={"studio"}
            />
          </div>
        )}

        <div className="relative flex-1 flex flex-col gap-0 items-center">
          {isAugmentedOpen && (
            <Button
              variant={VarianButtonEnum.SECONDARYICONBUTTON}
              icon={IconModelEnum.CLOSE}
              customClassNames="absolute bottom-4 right-4 p-4 z-50"
              onClickEvent={() => { setIsAugmentdOpen(false); }}
            />
          )}

          <div className="flex relative flex-col gap-3 items-center justify-center mt-auto pb-5">
            {(
              isEmailForLocalesActive ||
              isContactDealerLinkActive
            ) && (
              <Typography
                tag="h3"
                className="text-2xl sm:text-3xl w-[85%] sm:w-[60%] md:w-[70%] lg:w-[60%] xl:w-[55%] font-bold text-center mx-auto mb-3"
              >
                {DataContainer.sectionKey(SummarySettings.SUMMARY, SummarySettings.SUMMARY_TAGLINE)}
              </Typography>
            )}

            <div  className={`flex flex-col sm:flex-row gap-3 flex-1 justify-center items-center ${
              isMobile ? "xl:w-[80%]" : "xl:w-[40%]"
            }`}>
              {isContactDealerLinkActive && (
                <Button
                  textTransform={false}
                  customClassNamesSpan="!normal-case"
                  variant={VarianButtonEnum.PRIMARY}
                  text={DataContainer.sectionKey(SummarySettings.SUMMARY, SummarySettings.CONTACT_DEALER_BUTTON)}
                  customClassNames="flex items-center justify-center bg-[#2a609d] hover:bg-[#4781c4] active:bg-[#234d7d]
                    text-white text-sm font-medium py-3.5 px-6 rounded-md whitespace-nowrap
                    focus:outline-none focus:ring-2 focus:ring-[#234d7d] focus:ring-offset-2 focus:ring-offset-white"
                  onClickEvent={() => {
                    scrollToMap();
                    DataContainer.sendDataToAdobeDataLayer(AdobeEventType.APPLICATION_INTERACTION, StepNumbers.STEP_8, StepNames.SUMMARY, SubStepNames.SUMMARY, AdobeEventActions.CTA_CONTACT_DEALER, {}, "");
                  }}
                />
              )}
              {isEmailForLocalesActive && (
                <Button
                  variant={VarianButtonEnum.PRIMARY}
                  textTransform={false}
                  customClassNamesSpan="!normal-case"
                  text={DataContainer.sectionKey(SummarySettings.SUMMARY, SummarySettings.SAVE_LATER)}
                  customClassNames="flex items-center justify-center bg-white hover:bg-[#f7f7f7] text-sm text-black border
                    border-[#141414b3] rounded-md py-3.5 px-4 focus:outline-none focus:ring-2 focus:ring-[#234d7d]
                    focus:ring-offset-2 focus:ring-offset-white"
                  onClickEvent={() => {
                    setIsModalOpen(true);
                    DataContainer.sendDataToAdobeDataLayer(AdobeEventType.APPLICATION_INTERACTION, StepNumbers.STEP_8, StepNames.SUMMARY, SubStepNames.SUMMARY, AdobeEventActions.CTA_EMAIL_CONFIGURATION_OPEN_FORM, {}, "");
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </Page>
      <InfoShield />
      <div className="w-full relative z-10">
        <div className="flex flex-col justify-center items-center !border-b border-grey-light pb-5">
          <div className="flex justify-center gap-5 items-center">
            {isDownloadPdfActive && renderControlKey === 0 ? <></> : <PdfDocument
              exteriorImg={exteriorImageSource}
              interiorImg={interiorImageSource}
              variants={filteredVariations}
              title={currentProductData?.product_info?.name || ""}
              disabledAndLoading={!((exteriorImageSource || interiorImageSource) && selectedVariations?.length > 0)}
            />}
            {isDownloadProductImageActive &&
                <Button
                  variant={VarianButtonEnum.ICONBUTTON}
                  icon={isLoadingZip ? IconModelEnum.LOADING : IconModelEnum.SAVE}
                  text="PNG"
                  customClassNamesSpan="group-hover:text-blue-900"
                  customClassNames="!bg-white group text-[#004fbc] !rounded h-5 !px-0 !py-0
                  focus:outline-none focus:ring-2 focus:ring-[#234d7d] focus:ring-offset-2 focus:ring-offset-white"
                  disabled={isLoadingZip}
                  onClickEvent={() => {
                    downloadImages({
                      imageSpecs: [
                        getRenderSpec("010", false, true, false, isHighRes),
                        getRenderSpec("020", false, true, false, isHighRes),
                        getRenderSpec("030", false, true, false, isHighRes),
                        getRenderSpec("040", false, true, false, isHighRes),
                        getRenderSpec("050", false, true, false, isHighRes),
                        getRenderSpec("driverView", true, false, false, isHighRes),
                        getRenderSpec("bedView", true, false, false, isHighRes)

                      ],
                      productName: currentProductData?.product_info?.name || "",
                      format: "png"
                    });

                    DataContainer.sendDataToAdobeDataLayer(AdobeEventType.APPLICATION_INTERACTION, StepNumbers.STEP_8, StepNames.SUMMARY, SubStepNames.SUMMARY, AdobeEventActions.DOWNLOAD_CONFIGURATION, {}, FileFormatTypes.PNG);
                  }
                  }
                />
            }
            {isDownloadProductImageActive &&
                <Button
                  variant={VarianButtonEnum.ICONBUTTON}
                  icon={isLoadingJPEGZip ? IconModelEnum.LOADING : IconModelEnum.SAVE}
                  bgColor={colorButton.BLUE}
                  text="JPG"
                  customClassNamesSpan="group-hover:text-blue-900"
                  customClassNames="!bg-white group text-[#004fbc] !rounded h-5 !px-0 !py-0
                  focus:outline-none focus:ring-2 focus:ring-[#234d7d] focus:ring-offset-2 focus:ring-offset-white"
                  disabled={isLoadingJPEGZip}

                  onClickEvent={() => {
                    downloadImages({
                      imageSpecs: [
                        getRenderSpec("010", false, true, false, isHighRes),
                        getRenderSpec("020", false, true, false, isHighRes),
                        getRenderSpec("030", false, true, false, isHighRes),
                        getRenderSpec("040", false, true, false, isHighRes),
                        getRenderSpec("050", false, true, false, isHighRes),
                        getRenderSpec("driverView", true, false, false, isHighRes),
                        getRenderSpec("bedView", true, false, false, isHighRes)

                      ],
                      productName: currentProductData?.product_info?.name || "",
                      format: "jpg"
                    });

                    DataContainer.sendDataToAdobeDataLayer(AdobeEventType.APPLICATION_INTERACTION, StepNumbers.STEP_8, StepNames.SUMMARY, SubStepNames.SUMMARY, AdobeEventActions.DOWNLOAD_CONFIGURATION, {}, FileFormatTypes.JPG);
                  }
                  }
                />
            }
            <div className="relative">
              {isEnvelopeIconActive &&
                  <div className="absolute w-20 2md:w-36 overflow-x-hidden h-11 left-4 top-0 rounded-full">
                    <div
                      className="absolute flex items-center transition overflow-x-hidden ease-in-out duration-500 bg-gray-100 w-24 h-11 top-0 left-0 z-0 -right-20 rounded-full slider -translate-x-32"
                    >
                      <Button
                        variant={VarianButtonEnum.DEFAULT}
                        icon={IconModelEnum.MESSAGEBLACK}
                        bgColor={colorButton.WHITE}
                        onClickEvent={() => {
                          setIsModalOpen(true);
                          DataContainer.sendDataToAdobeDataLayer(AdobeEventType.APPLICATION_INTERACTION, StepNumbers.STEP_8, StepNames.SUMMARY, SubStepNames.SUMMARY, AdobeEventActions.CTA_EMAIL_CONFIGURATION_OPEN_FORM, {}, "");
                        }}
                        customClassNames={classNames(
                          { "pointer-events-none opacity-50": !isEmailForLocalesActive },
                          "ml-14 mr-6")}
                      />
                    </div>
                  </div>}
            </div>
          </div>
        </div>
      </div>
      <div className="mb-20 pt-28 text-center text-light-grey" id="overview" ref={variationsRef}>
        <Typography tag="h3" className="text-3xl3 font-bold mb-3.5 uppercase">
          {currentProductData ? currentProductData?.product_info?.name: ""}
        </Typography>
        <Typography tag="h3" className="text-3xl">
          {DataContainer.sectionKey(SummarySettings.SUMMARY, SummarySettings.OVERVIEW_CONFIGURATION)}
        </Typography>
      </div>
      <div className={classNames(
        "flex pb-6 mb-24 mx-9",
        {"mb-2" : isSelectMarketActive})}
      >
        <Swiper
          direction="horizontal"
          mousewheel={{releaseOnEdges: false}}
          freeMode={true}
          slidesPerView={1.5}
          spaceBetween={16}
          breakpoints={customBreakpoints}
        >
          {filteredVariations?.map((variant: Variation, index: number) => (
            <SwiperSlide key={index} className="mr-0 ">
              <SelectedVariants
                image={variant?.assets[0]?.preview_image_url}
                category={translateComponentName(variant)}
                readMoreLink={
                  (DataContainer.sectionKey(SummarySettings.SUMMARY, `readmore_${currentProductData?.product_info?.description}`))}
                subCategory={translateVariation(variant)}
                backgroundColor={dataContainer.variationBelongsToColorizer(variant) ? `#${variant.original_key.slice(2)}` : undefined}
                key={variant?.id || index}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {isContactFormActive &&
        <div>
          {!isSelectMarketActive ?
            <div className="flex flex-col 2md:flex-row bg-primary" ref={formRef}>
              {(isChooseDealerActive && !showSalesforce) &&
                <div className="2md:w-1/2">
                  <iframe
                    className="w-full h-[950px] 2md:h-full" 
                    src={mapSrc}
                    title="map"
                  />
                </div>
              }
              <div className={classNames("p-4 md:p-16 xl:p-32 px-auto",
                {"flex flex-col gap-4 2md:w-full": showSalesforce},
                {"2md:w-1/2": !showSalesforce},
              )}>
                <div className="text-light-grey  text-center xl:text-left lg:text-left">
                  <Typography tag="h3" className="uppercase text-xl text-light-grey">
                    {DataContainer.sectionKey(
                      ContactDealerFormSettings.CONTACT_DEALER_FORM,
                      ContactDealerFormSettings.CONTACT_DEALER_TITLE
                    )}
                  </Typography>
                  <Typography tag="p" className="text-2xl2 font-normal leading-medium py-3">
                    {DataContainer.sectionKey(
                      ContactDealerFormSettings.CONTACT_DEALER_FORM,
                      ContactDealerFormSettings.CONTACT_DEALER_TEXT
                    )}
                  </Typography>
                </div>
                {showSalesforce ? 
                  <SalesforceForm
                    resetRef={resetRef}
                    renderControlKey={renderControlKey}
                    formData={formData}
                    onChange={onChange}
                    isEmailValid={isEmailValid}
                    onCheckboxChange={onCheckboxChange}
                    marketingCheckboxErrorIndicator={marketingCheckboxErrorIndicator}
                    requiredInput={requiredInput}
                    requiredFields={requiredFields}
                    captchaRequired={captchaRequired}
                    resetForm={resetForm}
                    contactFormModalOpen={contactFormModalOpen}
                    setContactFormModalOpen={setContactFormModalOpen}
                    salesforceStatus={salesforceStatus}
                    salesforceMessage={salesforceMessage}
                    submitForm={submitForm}
                    setCaptchaRequired={setCaptchaRequired}
                    showCTA={showCTA}
                    correctCaptcha={correctCaptcha}
                    setCorrectCaptcha={setCorrectCaptcha}
                    currentLocale={currentLocale}
                    locale={locale}
                    market={market}
                    isSubmitting={isSubmitting}
                  />
                  :
                  <AdobeCampaignForm
                    resetRef={resetRef}
                    renderControlKey={renderControlKey}
                    formData={formData}
                    onChange={onChange}
                    isEmailValid={isEmailValid}
                    onCheckboxChange={onCheckboxChange}
                    marketingCheckboxErrorIndicator={marketingCheckboxErrorIndicator}
                    privacyCheckboxErrorIndicator={privacyCheckboxErrorIndicator}
                    requiredInput={requiredInput}
                    requiredFields={requiredFields}
                    captchaRequired={captchaRequired}
                    resetForm={resetForm}
                    contactFormModalOpen={contactFormModalOpen}
                    setContactFormModalOpen={setContactFormModalOpen}
                    salesforceStatus={salesforceStatus}
                    salesforceMessage={salesforceMessage}
                    submitForm={submitForm}
                    setCaptchaRequired={setCaptchaRequired}
                    showCTA={showCTA}
                    correctCaptcha={correctCaptcha}
                    setCorrectCaptcha={setCorrectCaptcha}
                    chosenDealerRef={chosenDealerRef}
                    onChangeDropdown={onChangeDropdown}
                    onChangeRegions={onChangeRegions}
                    regionSelected={regionSelected}
                    showSalesForceFields={isSalesforceActive}
                    isSubmitting={isSubmitting}
                  />
                }
                
                <DisclaimerSection
                  positionOfTitle="left"
                  positionOfContent="left"
                  links={[
                    {
                      title: DataContainer.sectionKey(DisclaimerTexts.MAIN_DISCLAIMER, DisclaimerTexts.PRIVACY_BUTTON),
                      link: DataContainer.sectionKey(DisclaimerTexts.MAIN_DISCLAIMER, DisclaimerTexts.PRIVACY_URL),
                    },
                    {
                      title:  DataContainer.sectionKey(DisclaimerTexts.MAIN_DISCLAIMER, DisclaimerTexts.COOKIES_BUTTON),
                      link: DataContainer.sectionKey(DisclaimerTexts.MAIN_DISCLAIMER, DisclaimerTexts.COOKIES_URL),
                    },
                  ]}
                  positionOfLinks="left"
                  isSummary
                />
              </div>
            </div>
            :
            <div className="pb-20">
              <div className="pb-10 md:w-1/5 w-4/5 mx-auto text-center items-center">
                <Dropdown
                  selectedOption={localeFromDropdown}
                  variant="secondary"
                  label="SELECT MARKET"
                  labelTransitions={false}
                  onChangeEvent={(e: React.ChangeEvent<HTMLSelectElement>) => {
                    setLocaleFromDropdown(e.currentTarget.value);
                    setLocaleIDfromDropdown(e.target.options[e.currentTarget.selectedIndex].id);
                  }}
                  toggleTextCenter
                  options={localesList}
                />
              </div>
              <div className="flex justify-center">
                <Button
                  variant={VarianButtonEnum.PRIMARY}
                  onClickEvent={() => {
                    window.open(getDropdownRedirectionURL(localeIDfromDropdown), "_blank");
                  }}
                  text="CONFIRM"
                />
              </div>
            </div>
          }
        </div>
      }
      {
        isModalOpen &&
          <Modal
            setIsOpen={setIsModalOpen}
            configuration={getUniqueHashForSelections()}
            locale={currentLocale?.locale as string}
            frontalTruckImage={exteriorImageSource}
          />
      }
    </div>
  );
}

export default Summary;

